import { render, staticRenderFns } from "./AdminInstitutionGroupForm.vue?vue&type=template&id=7734eab9&"
import script from "./AdminInstitutionGroupForm.vue?vue&type=script&lang=js&"
export * from "./AdminInstitutionGroupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports